import { render, staticRenderFns } from "./BCustomSpinner.vue?vue&type=template&id=79131d84&"
import script from "./BCustomSpinner.vue?vue&type=script&lang=js&"
export * from "./BCustomSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports